// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Lca-z","narrowOptionButtons":"Mca-z","noOptions":"Nca-z"};